import React, { useContext, useState } from "react";
import { UserContext } from "../../Context/UserContext";
import Button from "../../Reusable/Button";
import ItemWithBrandPageForm from "../../masterFormPages/ItemWithBrandPageForm";
import { BrandSelect } from "../../Reusable/BrandSelect";
import toast from "react-hot-toast";
import { BaseURL } from "../../Reusable/BaseURL";
import { ItemNameSelect } from "../../Reusable/ItemNameSelect";

export default function ItemWithBrand() {
  const { darkTheme, loginData, allPermiss } = useContext(UserContext);
  const [brand, setBrand] = useState("");
  const [itemCategory, setItemCategory] = useState("");

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [changingSelect, setChangingSelect] = useState(false);
  const [submitAction, setSubmitAction] = useState("submit");

  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  // create Division
  async function createDivision(e) {
    e.preventDefault();
    setSubmitDisable(true);
    const formData = new FormData();
    formData.append("brand_id", brand.value || null);
    formData.append("item_id", itemCategory.value || null);

    // const formData = {
    //   brand_id: brand.value || "",
    //   item_id: itemCategory.value || "",
    // };

    const res = await fetch(`${BaseURL}/brand-items`, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        // "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          firstPageList();
          toast.success("Success");
          setBrand("");
          setItemCategory("");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.status === false) {
          toast.error("Please select Item and Brand");
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/brand-items?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((divisionList) => {
        if (divisionList?.status) {
          const revData = divisionList.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(divisionList.data.total);
          setLinks(divisionList.data.links);
          setFrom(divisionList.data.from);
          setTo(divisionList.data.to);
          setSpinner(false);
        }
      });
  }

  function editBtn(editData) {
    if (editData) {
      setEditDisable(true);
      setChangingSelect(true);
      setSubmitAction("update");
      setBrand(editData.brand_name || "");
      setItemCategory(editData.item_name || "");
      setEditDisable(false);

      // TOP SCROLLING ==========
      // const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // You can use 'auto' instead of 'smooth' for instant scrolling
      });
      // };
      toast.success("Go to update form");
    } else {
      setChangingSelect(false);
      setEditDisable(false);
    }
  }
  // UPDATE A RECORD
  async function updateARecord(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    const formData = { item_id: itemCategory.value, brand_id: brand.value };
    const updRes = await fetch(`${BaseURL}/brand-items/${id}`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({name: divisionName}),
    })
      .then((res) => res.json())
      .then((upd) => {
        if (upd.status) {
          firstPageList();
          setGetId(0);
          toast.success("Updated");
          setBrand("");
          setItemCategory("");
          setSubmitAction("submit");
          setUpdateDisable(false);
        }
        if (upd.status === false) {
          setUpdateDisable(false);
        }
        if (upd?.status === false) {
          toast.error("Please select Item and Brand");
        }
      });
  }
  function cancelFun() {
    setSubmitAction("submit");
    setBrand("");
    setItemCategory("");
    setGetId(0);
    setUpdateDisable(false);
    setSubmitDisable(false);
    setEditDisable(false);
  }

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Item with Brand Master
          </div>
          <div className="flex flex-col gap-8 md:gap-5 md:flex-row lg:flex-row">
            {allPermiss?.includes("master-item-itembrand-create") && (
              <div className="w-full px-2 md:w-1/4">
                <form action="">
                  <div className="mb-2">
                    <label>
                      Item <span className="text-red-500 font-bold">*</span>
                    </label>
                    <ItemNameSelect
                      selectedOption={itemCategory}
                      setSelectedOption={setItemCategory}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <div className="mb-2">
                    <label>
                      Brand <span className="text-red-500 font-bold">*</span>
                    </label>
                    <BrandSelect
                      selectedOption={brand}
                      setSelectedOption={setBrand}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>

                  {allPermiss?.includes("master-item-itembrand-create") &&
                    submitAction === "submit" && (
                      <div className="flex items-center justify-start gap-x-1">
                        <Button
                          disabled={submitDisable}
                          type="submit"
                          onClick={(e) => createDivision(e)}
                        >
                          {submitDisable ? "Wait.." : "Submit"}
                        </Button>
                        <Button type="button" onClick={() => cancelFun()}>
                          Clear
                        </Button>
                      </div>
                    )}
                  {allPermiss?.includes("master-item-itembrand-update") &&
                    submitAction === "update" && (
                      <div className="flex items-center justify-start gap-x-1">
                        <Button
                          disabled={updateDisable}
                          type="submit"
                          onClick={(e) => updateARecord(e, getId)}
                        >
                          {updateDisable ? "Wait.." : "Update"}
                        </Button>
                        <Button
                          onClick={() => {
                            setSubmitAction("submit");
                            setBrand("");
                            setItemCategory("");
                            setGetId(0);
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                    )}
                </form>
              </div>
            )}
            {allPermiss?.includes("master-item-itembrand-view") && (
              <div className="w-full px-2 md:w-[75%]">
                <ItemWithBrandPageForm
                  editBtn={editBtn}
                  firstPageList={firstPageList}
                  links={links}
                  firstPage={firstPage}
                  setGetId={setGetId}
                  spinner={spinner}
                  totalNo={totalNo}
                  from={from}
                  to={to}
                  editDisable={editDisable}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
